import QrReader from 'modern-react-qr-reader';

import './QrScanner.css';

const QrScanner = (props) => {
    const { handleScan, handleError, step } = props;

    return (
        <div>
            <h1>{step}</h1>
            <QrReader 
                className='QrReader' 
                onScan={handleScan}
                onError={handleError}
            />
        </div>
    )
}

export default QrScanner;